import {Record} from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
    products: [],
    selectedItemsIds: [],
    paidOrders: [],
    filteredOrders: [],
    participants: [],
    prizesCount: 1,
    winners: [],
    credenciados: [],
    gameId: null,
});

function updateFilteredOrders(state) {
    const ordersWithSelectedItem = state.paidOrders.filter(o => o.items.some(i => state.selectedItemsIds.some(id => i.id_produto == id)));
    return state.set('filteredOrders', ordersWithSelectedItem);
}

function namesFromFilteredOrders(state) {
    const pairsFromOrders = (order) => order.items.map(i => ({nome: order.nome, item: i}));
    const nameAndItemPairs = state.filteredOrders.reduce((pairs, order) => pairs = pairs.concat(pairsFromOrders(order)), []);
    const relevantPairs = nameAndItemPairs.filter(p => state.selectedItemsIds.includes(p.item.id_produto));
    // a frequência do nome é igual seu peso: pedido com k itens-filtro garante o nome k vezes
    return relevantPairs.reduce((names, pair) => names = names.concat(_.fill(Array(pair.item.quantidade), pair.nome)), []);
}

function accreditedNames(state) {
    return state.credenciados.map(c => c.name);
}

function runLottery(state) {
    const filteredNames = namesFromFilteredOrders(state);
    const names = filteredNames.length != 0 ? filteredNames : accreditedNames(state);
    _.remove(names, (name) => state.winners.includes(name));
    return state.set('participants', _.shuffle(names));
}

class SorteioStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.CLOSE_LOTTERY:
                return updateFilteredOrders(state.set('selectedItemsIds', []))
                    .set('prizesCount', 1)
                    .set('winners', []);

            case ActionTypes.UPDATE_LOTTERY_CONFIG:
                return updateFilteredOrders(state.set(action.field, action.value));

            case ActionTypes.LIST_PAID_ORDERS_FINISH:
                return state
                    .set('paidOrders', action.itens);

            case ActionTypes.RUN_LOTTERY:
                return runLottery(state);

            case ActionTypes.SELECT_PRODUCTS_FINISH:
                return state
                    .set('products', action.produtos);

            case ActionTypes.LIST_PARTICIPANTS_FINISH:
                return state
                    .set('credenciados', action.participants.filter(p => p.badge));

            case ActionTypes.CREATE_LOTTERY_GAME_FINISH:
                return state
                    .set('gameId', action.id);

            default:
                return state;
        }
    }
}

export default new SorteioStore();



// WEBPACK FOOTER //
// src/stores/SorteioStore.js